<!--
  @Description: 
  @Author: wang.y 
  @Date: 2024-07-30 
-->
<template>
  <div class="main-container">
    <page-header>{{'我的订单' | dealLanguage('Orders and Invoices')}}</page-header>
    <div class="warp">
      <div class="order-list">
        <div class="order-item ticket-container" v-for="item,index in list" :key="index">
          <div class="order-item-top">
            <div class="ticket-item">
              <div class="ticket-item-top">
                <div class="ticket-item-top-left">
                  <img :src="item.activityShareImagePath | logo_show" />
                  <!-- <img :src="item.activityLogoPath | logo_show" /> -->
                </div>
                <div class="ticket-item-top-right">
                  <div>
                    <div class="title">{{item.activityTicketName | dealLanguage(item.activityEnTicketName)}}</div>
                    <div class="desc" v-html="item.remark" v-if="item.remark && language == 'zh'"></div>
                    <div class="desc" v-html="item.enRemark" v-if="item.enRemark && language == 'en'"></div>
                  </div>
                </div>
              </div>
              <!-- <div class="participant" v-if="item.receiveXuserId == 0">{{'参会人信息：' | dealLanguage('Participant information:')}}{{user.name}} +{{user.mobileAreaCode}} {{user.mobile}}</div>
              <div class="participant" v-else>{{'参会人信息：' | dealLanguage('Participant information:')}}{{item.receiveXuserName}} +{{item.receiveXuserMobileAreaCode}} {{item.receiveXuserMobile}}</div> -->
              <div class="participant" v-if="language == 'zh'">参会人信息：{{user.name}} +{{user.mobileAreaCode}} {{user.mobile}}</div>
              <div class="participant" v-else>Participant information:{{user.email}}</div>
            </div>
            <div class="order-info">
              <div class="order-info-item">
                <div class="title">{{'支付状态' | dealLanguage('Payment status')}}</div>
                <div class="value success" v-if="item.refundStatus == 0">{{'已支付' | dealLanguage('Paid')}}</div>
                <div class="value grey" v-if="item.refundStatus == 1">{{'已取消' | dealLanguage('Cancelled')}}</div>
                <div class="value warning" v-if="item.refundStatus == 2">{{'退款中' | dealLanguage('Refunding')}}</div>
                <div class="value error" v-if="item.refundStatus == 3">{{'拒绝退款' | dealLanguage('Refusal to refund')}}</div>
              </div>
              <div class="order-info-item">
                <div class="title">{{'购票数量' | dealLanguage('Number of tickets')}}</div>
                <div class="value">{{item.ticketNumber}}</div>
              </div>
              <div class="order-info-item">
                <div class="title">{{'支付金额' | dealLanguage('Amount')}}</div>
                <div class="value">{{'￥' | dealLanguage('$')}}{{item.paymentAmount}}</div>
              </div>
              <div class="order-info-item">
                <div class="title">{{'订单号' | dealLanguage('Order number')}}</div>
                <div class="value">{{item.orderNumber}}</div>
              </div>
              <div class="order-info-item">
                <div class="title">{{'订单时间' | dealLanguage('Order time')}}</div>
                <div class="value">{{item.orderCreateTime}}</div>
              </div>
            </div>
          </div>
          <div class="bottom-btn-wrapper">
            <template v-if="(item.refundStatus == 0 || item.refundStatus == 3) && language == 'zh'">
              <Button @click="handleAction('apply-invoice', item, index)" v-if="item.invoiceStatus == 0">{{'申请发票' | dealLanguage('Invoice')}}</Button>
              <span class="spa1" v-if="item.invoiceStatus == 1">{{'发票申请中' | dealLanguage('Invoice claiming')}}</span>
              <span class="spa2" @click="handleAction('apply-invoice', item, index)" v-if="item.invoiceStatus == 1">{{'查看发票信息' | dealLanguage('View invoice')}}</span>
              <span class="spa3" v-if="item.invoiceStatus == 2">{{'发票已开，请注意查收' | dealLanguage('Invoice Sent, please check')}}</span>
            </template>
            <Button @click="handleLookInvoice(item.paypalInvoiceFilePath)" v-if="language != 'zh'">Invoice</Button>
            <Button @click="handleAction('apply-refund', item, index)" v-if="item.refundStatus == 0 && item.invoiceStatus == 0 && item.paymentAmount">{{'申请退款' | dealLanguage('Refund')}}</Button>
            <Button @click="handleChangeRouter('contactUs')">{{'联系客服' | dealLanguage('Contact Us')}}</Button>
          </div>
        </div>
      </div>
      <div class="loading-warpper" v-if="loading">
        <van-loading size="20px">{{'加载中' | dealLanguage('Loading')}}...</van-loading>
      </div>
      <nothing v-if="!isMore && !loading && list.length == 0">
        <router-link :to="{name: 'signUp'}" class="btn">{{'前往购票' | dealLanguage('Get tickets')}}</router-link>
      </nothing>
    </div>
    <div ref="indexlist-bottom"></div>
    <apply-invoice ref="apply-invoice" @success="handleInvoiceSuccess"></apply-invoice>
    <apply-refund ref="apply-refund" @success="handleRefundSuccess"></apply-refund>
  </div>
</template>
<script>
import Nothing from '@/components/common/nothing.vue'
import PageHeader from '@/components/mobile/pageHeader.vue'
import ApplyInvoice from '@/components/mobile/applyInvoice.vue'
import ApplyRefund from '@/components/mobile/applyRefund.vue'
import { orderList } from '@/service/vbef'
import { mapState } from 'vuex'
import filter from 'js/filter'
export default {
  metaInfo() {
    return {
      title: filter.dealLanguage('我的订单', 'Orders and Invoices'),
    }
  },
  inject: ['wxShare'],
  components: {
    Nothing,
    PageHeader,
    ApplyInvoice,
    ApplyRefund,
  },
  created() {
    this.getOrderList()
  },
  mounted() {
    this.wxShare({
      title: filter.dealLanguage('我的订单-CSGCT', 'Orders and Invoices-CSGCT'),
      linkurl: this.vbef_path + '/orderList',
      
    })
    if (!this.user_key) {
      this.$router.push('/')
      this.$notify(filter.dealLanguage('请先登录', 'Please log in first'))
    }
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  data() {
    return {
      page: 1,
      list: [],
      loading: false,
      isMore: false,
    }
  },
  computed: {
    ...mapState({
      user_key: (state) => state.user_key,
      user: (state) => state.user,
      static_img_url: (state) => state.static_img_url,
      vbef_path: (state) => state.vbef_path,
      language: (state) => state.language,
    }),
  },
  methods: {
    handleScroll() {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      let windowHeight = document.documentElement.clientHeight || document.body.clientHeight

      const listbox = this.$refs['indexlist-bottom']
      const listrect = listbox.getBoundingClientRect()
      const listabsoluteTop = listrect.top + scrollTop
      if (
        scrollTop + windowHeight >= listabsoluteTop &&
        scrollTop > 0 &&
        !this.loading &&
        this.isMore
      ) {
        this.getMore()
      }
    },
    async getOrderList() {
      this.loading = true
      let res = await orderList({
        dataType: 2,
        page: this.page,
        size: 10,
        ticketStatus: 0,
        userKey: this.user_key,
        ticketType: 1,
      })
      this.loading = false
      if (res.code == 0) {
        this.list = [...this.list, ...res.data]
        this.isMore = res.data.length == 10
      }
    },
    getMore() {
      this.page++
      this.getOrderList()
    },
    handleChangeRouter(name) {
      this.$router.push({ name: name })
    },
    handleAction(action, item, index) {
      this.$refs[action].modelIndex = true
      this.$refs[action].orderItem = { ...item }
      this.$refs[action].orderIndex = index
    },
    handleInvoiceSuccess(res, index) {
      if (this.list[index]) {
        Object.assign(this.list[index], {
          header: res.header,
          headerType: res.headerType,
          type: res.type,
          uniformSocialCreditCode: res.uniformSocialCreditCode,
          email: res.email,
          invoiceStatus: res.invoiceStatus,
        })
      }
    },
    handleRefundSuccess(index) {
      if (this.list[index]) {
        Object.assign(this.list[index], {
          refundStatus: 2,
        })
      }
    },
    handleLookInvoice(url) {
      window.location.href = url
    },
  },
}
</script>
<style lang='stylus' scoped>
@import '~styles/common-m.styl'
@import '~styles/form-view-m.styl'
@import '~styles/ticket-item-m.styl'
.warp
  padding 0.4rem
.order-list
  .order-item
    &:not(:first-of-type)
      margin-top 0.2rem
    &-top
      .order-info
        margin-top 0.3rem
        .order-info-item
          display flex
          justify-content space-between
          font-size 0.28rem
          line-height 0.39rem
          &+div
            margin-top 0.15rem
          .title
            color #999999
          .value
            color #333333
            &.success
              color #08C161
            &.grey
              color #999999
            &.warning
              color #FF9700
            &.error
              color #ED4014
</style>